import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=d6bd8f5a&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&id=d6bd8f5a&prod&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=d6bd8f5a&prod&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&id=d6bd8f5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bd8f5a",
  null
  
)

export default component.exports